module.exports = __webpack_public_path__ + "whitescentcandle.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/whitescentcandle.png
// module id = 902
// module chunks = 0